export default __webpack_public_path__ + "static/media/logo-icon.5e25f691.png";